<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-layout row wrap align-center class="mb-2 mt-3">
          <v-flex>
            <h3>
              {{$t('common.other_image')}}
              
            </h3>
            <!--ro /sadf -->
          </v-flex>
          <v-flex>
            <slot name="findingAction" />
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- 圖片 -->
      
    </v-layout>
    <!-- Other images -->
    <div v-if="otherImages.length">
      <div
        class="ml-2 break-inside-page"
        style="padding: 5px"
      >
        <FindingItemImages 
          :finding="{
            images: otherImages
          }" 
          :imgArrange="imgArrange" 
          :showName="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FindingItemImages from '@/components/preview/FindingItemImages.vue'
import FindingMixin from '@/mixins/findingMixins.js'
export default {
  name: 'FindingOtherImages',
  mixins: [FindingMixin],
  components: {
    FindingItemImages
  },
  props: {
    findings: {
      type: Array,
      required: true,
      default: () => []
    },
    images: {
      type: Array,
      default: () => []
    },
    imgArrange: {
      type: Number,
      default: 3
    }
  },
  computed: {
    otherImages() {
      if (!this.images || !this.findings) return []
      let _tmpArr = []
      // 檢查 images 是否有對應的findingID, 抓出沒有對到的
      _tmpArr = this.images.filter((img) => !this.findings.find((finding) => finding.id === img.findingID ) && img.status != 0)
      return _tmpArr
    },
    ro() {
      if (!this.finding) return
      const text = this.finding.lesions.map((lesion) => lesion.ro).join('')
      return text && `r/o:${text}`
    },
    // 目前只看到在胃鏡出現
    earlyAdv() {
      if (!this.finding) return
      return this.finding.lesions.map((lesion) => lesion.earlyAdv).join('')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/components/reportImgArrange.scss';
.finding-item-images {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  gap: 10px;
  width: 100%;
  align-items: center;
}
.finding-item-images img{
  width: 240px;
}
</style>
